import {DeviceStatus} from '@app/core-shared';

export const deviceStatusEnumOptions = [
  { value: DeviceStatus.Created, label: 'orga-portal.devices.status-types.0' },
  { value: DeviceStatus.Registered, label: 'orga-portal.devices.status-types.1' },
  { value: DeviceStatus.Deleted, label: 'orga-portal.devices.status-types.2' },
  { value: DeviceStatus.Inactive, label: 'orga-portal.devices.status-types.3' },
];

